module.exports = __webpack_public_path__ + "static/media/Logo.e533bd92.svg";